import React, { useState } from 'react';
import { tokens as t, fonts as font } from '../../tokens';

export function Input({ placeholder, type = "text", icon, value, onChange, label, error, style: extraStyle = {}, ...props }) {
  const [focused, setFocused] = useState(false);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4, width: "100%" }}>
      {label && <label style={{ fontSize: 12, fontWeight: 700, color: t.textSecondary, fontFamily: font.body }}>{label}</label>}
      <div style={{ position: "relative", width: "100%" }}>
        {icon && (
          <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: t.textMuted, pointerEvents: "none", fontSize: 14 }}>{icon}</span>
        )}
        <input
          type={type} placeholder={placeholder} value={value} onChange={onChange}
          onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
          style={{
            width: "100%", padding: "10px 14px",
            paddingLeft: icon ? 38 : 14,
            background: t.surface,
            border: `1.5px solid ${error ? t.coral : focused ? t.emerald : t.border}`,
            borderRadius: 8, color: t.textPrimary, fontSize: 13,
            outline: "none", fontFamily: font.body,
            boxShadow: focused ? `0 0 0 3px ${t.emerald}18` : "none",
            transition: "all 0.15s",
            boxSizing: "border-box",
            ...extraStyle,
          }}
          {...props}
        />
      </div>
      {error && <span style={{ fontSize: 11, color: t.coral, fontFamily: font.body }}>{error}</span>}
    </div>
  );
}

export function Textarea({ placeholder, value, onChange, label, rows = 4, ...props }) {
  const [focused, setFocused] = useState(false);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4, width: "100%" }}>
      {label && <label style={{ fontSize: 12, fontWeight: 700, color: t.textSecondary, fontFamily: font.body }}>{label}</label>}
      <textarea
        placeholder={placeholder} value={value} onChange={onChange} rows={rows}
        onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
        style={{
          width: "100%", padding: "10px 14px",
          background: t.surface,
          border: `1.5px solid ${focused ? t.emerald : t.border}`,
          borderRadius: 8, color: t.textPrimary, fontSize: 13,
          outline: "none", fontFamily: font.body, resize: "vertical",
          boxShadow: focused ? `0 0 0 3px ${t.emerald}18` : "none",
          transition: "all 0.15s", boxSizing: "border-box",
        }}
        {...props}
      />
    </div>
  );
}

export function Select({ options = [], placeholder, value, onChange, label, ...props }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      {label && <label style={{ fontSize: 12, fontWeight: 700, color: t.textSecondary, fontFamily: font.body }}>{label}</label>}
      <div style={{ position: "relative" }}>
        <select
          value={value} onChange={onChange}
          style={{
            appearance: "none", padding: "10px 32px 10px 14px",
            background: t.surface, border: `1.5px solid ${t.border}`,
            borderRadius: 8, color: t.textPrimary,
            fontSize: 13, fontFamily: font.body, fontWeight: 500,
            cursor: "pointer", outline: "none",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
          }}
          {...props}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <span style={{ position: "absolute", right: 11, top: "50%", transform: "translateY(-50%)", pointerEvents: "none", color: t.textMuted, fontSize: 11 }}>▾</span>
      </div>
    </div>
  );
}

export function Checkbox({ checked, onChange, label }) {
  return (
    <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontFamily: font.body, fontSize: 13, color: t.textSecondary }}>
      <div
        onClick={() => onChange && onChange(!checked)}
        style={{
          width: 17, height: 17, borderRadius: 5,
          border: `1.5px solid ${checked ? t.emerald : t.borderDark}`,
          background: checked ? t.emerald : t.surface,
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all 0.15s", cursor: "pointer", flexShrink: 0,
        }}
      >
        {checked && <span style={{ color: "#fff", fontSize: 10, fontWeight: 700, lineHeight: 1 }}>✓</span>}
      </div>
      {label}
    </label>
  );
}

export function Toggle({ checked, onChange, label }) {
  return (
    <label style={{ display: "flex", alignItems: "center", gap: 9, cursor: "pointer", fontFamily: font.body, fontSize: 13, color: t.textSecondary }}>
      <div
        onClick={() => onChange && onChange(!checked)}
        style={{
          width: 38, height: 21, borderRadius: 99,
          background: checked ? t.emerald : "#d1d5db",
          position: "relative", cursor: "pointer", transition: "background 0.2s",
          boxShadow: checked ? `0 0 0 3px ${t.emerald}20` : "none",
        }}
      >
        <div style={{
          position: "absolute", top: 3, left: checked ? 20 : 3,
          width: 15, height: 15, borderRadius: "50%",
          background: "#fff", transition: "left 0.2s",
          boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
        }} />
      </div>
      {label}
    </label>
  );
}
